import { bulkRemoveLikedGoods } from './bulkRemoveLikedGoods';
import { deleteLikedGoods } from './deleteLikedGoods';
import { getLikedGoods } from './getLikedGoods';
import { getLikedGoodsCategories } from './getLikedGoodsCategories';
import { moveLikedGoods } from './moveLikedGoods';
import { postLikeGoods } from './postLikeGoods/postLikeGoods';
import { removeLikeGoods } from './removeLikeGoods';

/**
 * - 최근본 상품의 찜관련 관련 api
 */
export const likeGoodsService = {
  post: postLikeGoods,
  delete: removeLikeGoods,
  getLikedGoods,
  getLikedGoodsCategories,
  deleteLikedGoods,
  bulkDelete: bulkRemoveLikedGoods,
  bulkMove: moveLikedGoods,
};
